import apiClient from "./axiosConfig"

const url = '/subscriptions'

const getSubcriptionPlans = async() => await apiClient.get(url + '/plans')
const initiatePayment = async(data) => await apiClient.post(`${url}/initiate-payment/`, data)
const getMySubscription = async() => await apiClient.get(url + '/my-subscription/')
const cancelSubscription = async() => await apiClient.post(url + '/cancel/')
const updateAutoRenew = async(auto_renew) => await apiClient.patch(`${url}/update-auto-renewal/`, {auto_renew})
const updateSubscriptionPlan = async(plan_id) => await apiClient.patch(`${url}/update-plan/`, {plan_id})
const updatePaymentMethod = async(payment_method) => await apiClient.patch(`${url}/update-payment-method/`, {payment_method})
const getSubscriptionLimits = async() => await apiClient.get(`${url}/limits/`)
const getActiveGateways = async() => await apiClient.get(`${url}/active-gateways/`)

/**
 * Query STK Push status for M-Pesa / KCB MpesaExpress payments.
 * @param {string} checkout_request_id - The CheckoutRequestID from the STK push response
 * @param {boolean} force_verify - If true, forces a live API check even if DB status is pending
 */
const queryStkStatus = async(checkout_request_id, force_verify = false) =>
  await apiClient.post(`${url}/query-stk-status/`, { checkout_request_id, force_verify })

/**
 * Check subscription status by payment reference (used for IPN / interbank channels).
 * Polls the subscription record to detect when KCB IPN has activated it.
 * @param {string} reference - Payment reference (e.g. "SUB-1-42")
 */
const checkIpnStatus = async(reference) =>
  await apiClient.get(`${url}/my-subscription/`, { params: { ref: reference } })

const testKcbIpnCallback = async(data) =>
  await apiClient.post(`${url}/webhooks/kcb/ipn/`, data)

const testKcbCallback = async(data) =>
  await apiClient.post(`${url}/webhooks/kcb/test/`, data)

export default {
    getSubcriptionPlans,
    initiatePayment,
    getMySubscription,
    cancelSubscription,
    updateAutoRenew,
    updateSubscriptionPlan,
    updatePaymentMethod,
    getSubscriptionLimits,
    getActiveGateways,
    queryStkStatus,
    checkIpnStatus,
    testKcbIpnCallback,
    testKcbCallback,
}